import { registerSW } from 'virtual:pwa-register';

/**
 * Registers the service worker. `autoUpdate` means a new build activates on the next
 * navigation; we reload once so a technician is never left on stale code mid-shift.
 */
export function registerServiceWorker(): void {
  registerSW({
    immediate: true,
    onRegisterError(error) {
      console.error('Service worker registration failed', error);
    },
  });
}
